// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ESHOP_PILLS_ACCESSORIES = "P\u0159\u00edslu\u0161enstv\u00ed";
export const ESHOP_PILLS_CARSEATS = "Autoseda\u010dky";
export const ESHOP_PILLS_STROLLERS = "Ko\u010d\u00e1rky";
export const HOME_ESHOP_PILLS_MAIN = "Mamaleto E-shop";
